import axios from 'axios';

// Dominio del backend (ej: http://localhost:8080). Configurar en .env como REACT_APP_BACKEND_URL
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
const API_BASE = `${BACKEND_URL}/api/v1`;

// Crear instancia de axios
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token a todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// === Auth ===
export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  getMe: () => api.get('/auth/me'),
  listUsers: () => api.get('/auth/users'),
  createUser: (data) => api.post('/auth/register', data),
  updateUser: (id, data) => api.put(`/auth/users/${id}`, data),
};

// === Dashboard ===
export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
  getRecentMovements: (limit = 10) => api.get(`/dashboard/recent-movements?limit=${limit}`),
  getPendingOrders: (limit = 10) => api.get(`/dashboard/pending-orders?limit=${limit}`),
};

// === Units ===
export const unitsApi = {
  list: () => api.get('/units'),
  create: (data) => api.post('/units', data),
};

// === Products ===
export const productsApi = {
  list: (params = {}) => api.get('/products', { params }),
  get: (id) => api.get(`/products/${id}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
};

// === Warehouses ===
export const warehousesApi = {
  list: (params = {}) => api.get('/warehouses', { params }),
  get: (id) => api.get(`/warehouses/${id}`),
  getStocks: (id) => api.get(`/warehouses/${id}/stocks`),
  getAllStocks: (params = {}) => api.get('/warehouses/stocks', { params }),
  getLowStockAlerts: () => api.get('/warehouses/low-stock-alerts'),
  create: (data) => api.post('/warehouses', data),
  update: (id, data) => api.put(`/warehouses/${id}`, data),
  delete: (id) => api.delete(`/warehouses/${id}`),
};

// === Movements ===
export const movementsApi = {
  list: (params = {}) => api.get('/movements', { params }),
  get: (id) => api.get(`/movements/${id}`),
  getKardex: (productId, params = {}) => api.get(`/movements/kardex/${productId}`, { params }),
  create: (data) => api.post('/movements', data),
};

// === Suppliers ===
export const suppliersApi = {
  list: (params = {}) => api.get('/suppliers', { params }),
  get: (id) => api.get(`/suppliers/${id}`),
  create: (data) => api.post('/suppliers', data),
  update: (id, data) => api.put(`/suppliers/${id}`, data),
  delete: (id) => api.delete(`/suppliers/${id}`),
};

// === Purchase Orders ===
export const purchaseOrdersApi = {
  list: (params = {}) => api.get('/purchase-orders', { params }),
  get: (id) => api.get(`/purchase-orders/${id}`),
  create: (data) => api.post('/purchase-orders', data),
  update: (id, data) => api.put(`/purchase-orders/${id}`, data),
  send: (id) => api.post(`/purchase-orders/${id}/send`),
  cancel: (id) => api.post(`/purchase-orders/${id}/cancel`),
  receive: (id, data) => api.post(`/purchase-orders/${id}/receive`, data),
};

// === MRP ===
export const mrpApi = {
  getRecommendations: (params = {}) => api.get('/mrp/recommendations', { params }),
  listRules: (params = {}) => api.get('/mrp/rules', { params }),
  createRule: (data) => api.post('/mrp/rules', data),
  updateRule: (id, data) => api.put(`/mrp/rules/${id}`, data),
  deleteRule: (id) => api.delete(`/mrp/rules/${id}`),
};

// === Settings ===
export const settingsApi = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

export default api;
